<template>
    <div class="mx-auto col-lg-5 col-md-8 col-sm-10 header-margin">
        <div class="text-center p-2" style="margin-bottom: 30px">
            <h3>{{ $t('auth.changeEmail.lastTokenTitle') }}</h3>
        </div>
        <div class="show-check-email-message" v-html="$t('auth.notLatestTokenText')"></div><br />
        <div class="text-center">
            <div class="pb-4 ">
                <a class="btn btn-primary text-center-btn" href="/" role="button">{{$t('auth.changeEmail.buttom') }}</a>
            </div>
        </div>
    </div>
</template>

<script>
    import AuthUtil from '../../utils/AuthUtil';
    import UserService from "../../services/UserService";

    export default {
        name: 'change-email-error-module',
        methods: {
            async handleOnClickLogout(e) {
                try {
                    await UserService.revokeToken(AuthUtil.getAuthToken());
                } catch (e) {}
                AuthUtil.clearAuth();
                this.isOpenMenu = false;
                this.$router.go('/login');
            },
        }
    }
</script>

<style scoped>
    .success_email_img {
        max-width: 150px;
        width: 100%;
    }
    .show-check-email-message {
        text-align: center;
    }
    .show-check-email-message >>> br {
        display: inline;
    }
    @media screen and (max-width: 767px) {
        .show-check-email-message {
            text-align: left;
        }
        .show-check-email-message >>> br {
            display: none;
        }
    }
</style>
